var _style, _g, _path, _path2, _g2, _path3, _g3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#21A365;}\n\t.st1{fill:#107C41;}\n\t.st2{fill:#185B37;}\n\t.st3{fill:#33C481;}\n\t.st4{fill:#17864C;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#036C70;}\n\t.st7{fill:#1A9BA1;}\n\t.st8{fill:#37C6D0;}\n\t.st9{fill:#04878B;}\n\t.st10{fill:#4F59CA;}\n\t.st11{fill:#7B82EA;}\n\t.st12{fill:#4C53BB;}\n\t.st13{fill:#0F78D5;}\n\t.st14{fill:#29A7EB;}\n\t.st15{fill:#0358A8;}\n\t.st16{fill:#0F79D6;}\n\t.st17{fill:#038387;}\n\t.st18{fill:#048A8E;}\n\t.st19{fill:#C8421D;}\n\t.st20{fill:#FF8F6A;}\n\t.st21{fill:#ED6B47;}\n\t.st22{fill:#891323;}\n\t.st23{fill:#AF2131;}\n\t.st24{fill:#C94E60;}\n\t.st25{fill:#E08195;}\n\t.st26{fill:#B42839;}\n\t.st27{fill:#0464B8;}\n\t.st28{fill:#0377D4;}\n\t.st29{fill:#4FD8FF;}\n\t.st30{fill:#1681D7;}\n\t.st31{fill:#0178D4;}\n\t.st32{fill:#042071;}\n\t.st33{fill:#168FDE;}\n\t.st34{fill:#CA64EA;}\n\t.st35{fill:#7E1FAF;}\n\t.st36{fill:#AE4BD5;}\n\t.st37{fill:#9332BF;}\n\t.st38{fill:#7719AA;}\n\t.st39{fill:#0078D4;}\n\t.st40{fill:#1490DF;}\n\t.st41{fill:#0364B8;}\n\t.st42{fill:#28A8EA;}\n\t.st43{fill:#41A5ED;}\n\t.st44{fill:#2C7BD5;}\n\t.st45{fill:#195ABE;}\n\t.st46{fill:#103E91;}\n\t.st47{fill:#2166C3;}\n\t.st48{opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M120.2,22.8H34.2V9.1C34.2,6.8,36,5,38.2,5h77.9c2.3,0,4.1,1.8,4.1,4.1V22.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st28",
    height: 26.6,
    width: 28.7,
    x: 34.2,
    y: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    height: 26.6,
    width: 28.7,
    x: 62.9,
    y: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    height: 26.6,
    width: 28.7,
    x: 91.6,
    y: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st30",
    height: 26.6,
    width: 28.7,
    x: 34.2,
    y: 49.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    height: 26.6,
    width: 28.7,
    x: 62.9,
    y: 49.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    height: 26.6,
    width: 28.7,
    x: 91.6,
    y: 49.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    height: 26.6,
    width: 28.7,
    x: 62.9,
    y: 75.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st30",
    height: 26.6,
    width: 28.7,
    x: 91.6,
    y: 75.9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M126.9,69.1l-6.6,3.9V61.8l6.5,3.6C128.3,66.1,128.3,68.2,126.9,69.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M126.9,69.1l-0.6,0.4l0,0l-0.7,0.4l-5.3,3.1v-0.1l-88.4,50.6h89.1c3.8,0,6.8-3.1,6.8-6.8l0.1-49.4  C128,67.9,127.6,68.7,126.9,69.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M122,123.5H32.8c-3.8,0-6.8-3.1-6.8-6.8V68.5L122,123.5z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M59,96.5h-53c-3.5,0-6.4-2.9-6.4-6.4V37.9c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.4,93.6,62.6,96.5,59,96.5z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.5,82.9c-10.3,0-16.8-7.8-16.8-18.2c0-11,7.1-18.8,17.3-18.8c10.6,0,16.8,7.9,16.8,18.1   C49.9,76.1,42.5,82.9,32.5,82.9L32.5,82.9z M32.9,77.7c6.4,0,10-5.9,10-13.4c0-6.8-3.4-13.1-10-13.1s-10.1,6.2-10.1,13.4   S26.4,77.7,32.9,77.7L32.9,77.7z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M65.5,37.3c0,0.2,0,0.4,0,0.6v52.2c0,3.5-2.9,6.4-6.4,6.4H26v5.7h38.4c3.5,0,6.4-2.9,6.4-6.4V43.6  C70.8,40.4,68.5,37.7,65.5,37.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookIcon);
export default __webpack_public_path__ + "static/media/outlook-icon.a7d11640d7d507bfd7a21e1c88875168.svg";
export { ForwardRef as ReactComponent };